import { Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Result from "./Panels/Result";
import History from "./Panels/History";
import {
  vehicleTestResultApiUrl,
  vehiclePartAttributeApiUrl,
} from "../../../../Common/endpoints";
import { getApis } from "../../../../Common/apis";
import {
  setDynoResult,
  setDynoStartDetails,
  setDynoStopDetails,
  setDynoTestRunningStatus,
} from "../../../../../reducers/eolTestsSlice";
import { useCallback, useEffect, useState } from "react";
import Comment from "../Comment";
import { toast } from "react-toastify";
import { setNavStop } from "../../../../../reducers/authSlice";

const Dyno = ({ isModalOpen, handleCloseModal, onChangeImei, vehicle }) => {
  const dispatch = useDispatch();
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const dynoTestRunningStatus = eol?.dynoTestRunningStatus;
  const dynoStartDetails = eol?.dynoStartDetails;
  const dynoResult = eol?.dynoResult;
  const selectedTab = eol?.selectedTab;
  const authToken = localStorage.getItem("authToken");
  const [rearTyreDiameter, setRearTyreDiameter] = useState(null);

  const dynoResultApi = useCallback(async () => {
    const testId =
      dynoStartDetails?.testId || vehicleDetails?.previousTests?.dyno;
    if (testId) {
      const response = await getApis(
        vehicleTestResultApiUrl,
        {
          testId: testId,
          vIdVal: vehicleDetails?.vehId,
        },
        authToken
      );
      if (response?.data?.status === "COMPLETED") {
        dispatch(setDynoTestRunningStatus(false));
        dispatch(setNavStop(false));
      }
      dispatch(setDynoResult(response?.data));
    }
  }, [
    authToken,
    dispatch,
    dynoStartDetails?.testId,
    vehicleDetails?.vehId,
    vehicleDetails?.previousTests?.dyno,
  ]);

  useEffect(() => {
    let intervalId;

    if (
      dynoTestRunningStatus &&
      selectedTab === "dyno" &&
      vehicle?.vehImei !== dynoStartDetails.imei
    ) {
      dispatch(setNavStop(false));
      dispatch(setDynoStartDetails({}));
      dispatch(setDynoTestRunningStatus(false));
      dispatch(setDynoStopDetails({}));
    } else if (dynoTestRunningStatus && selectedTab === "dyno") {
      dispatch(setNavStop(true));
      intervalId = setInterval(() => {
        dynoResultApi();
      }, 5000);
      getVehiclePartAttribite();
    } else if (vehicleDetails?.previousTests?.dyno && selectedTab === "dyno") {
      dynoResultApi();
      getVehiclePartAttribite();
    }

    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, [dynoTestRunningStatus, vehicleDetails?.previousTests?.dyno, selectedTab]);

  const getVehiclePartAttribite = useCallback(async () => {
    if (vehicle?.vehId) {
      await getApis(
        vehiclePartAttributeApiUrl,
        {
          vIdVal: vehicle?.vehId,
          partType: "REAR_TYRE",
        },
        authToken
      )
        .then((response) => {
          setRearTyreDiameter(
            response?.data?.attributes?.rearTyreDiameter || null
          );
        })
        .catch((e) => toast.error(e.response?.data?.message));
    }
  }, [authToken, vehicle?.vehId]);

  return (
    <Row data-testid="dyno-tab-content" className="mb1">
      {isModalOpen ? (
        <Comment
          isModalOpen={isModalOpen}
          handleCloseModal={handleCloseModal}
          testId={dynoResult?.testId}
          formName={selectedTab}
        />
      ) : null}
      <Col span={24}>
        {dynoTestRunningStatus === true ? (
          <Result
            onChangeImei={onChangeImei}
            vehicle={vehicle}
            rearTyreDiameter={rearTyreDiameter}
          />
        ) : (
          <History
            onChangeImei={onChangeImei}
            vehicle={vehicle}
            rearTyreDiameter={rearTyreDiameter}
          />
        )}
      </Col>
    </Row>
  );
};

export default Dyno;
